import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import api from "../api";

const GoogleAuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const authCode = urlParams.get("code");

    if (authCode) {
      console.log("🔄 Sending OAuth code to Django...");

      
    api.post("/google-auth/", { code: authCode })
      .then(() => {
        console.log("✅ Login successful! Redirecting to dashboard...");
        navigate("/dashboard"); // ✅ Redirect to Dashboard
      })
      .catch((error) => {
        console.error("❌ OAuth Authentication Failed:", error);
        navigate("/login"); // Redirect to login on failure
      });
      
    } else {
      console.error("❌ No OAuth code found in URL.");
      navigate("/login");
    }
  }, [location, navigate]);

  return <p>Logging in...</p>; // Display while processing
};

export default GoogleAuthCallback;
